import { createSlice } from "@reduxjs/toolkit";

export const statusSlice = createSlice({
  name: "status",
  initialState: {
    authToken: null,
    user: null,
    showDashPopup: true,
    disConnectWallet: false
  },
  reducers: {
    setAuthToken: (state, action) => {
      state.authToken = action.payload; // Corrected field name to authToken
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setShowDashPopup: (state, action) => {
      state.showDashPopup = action.payload;
    },
    setDisConnectWallet: (state, action) => {
      state.disConnectWallet = action.payload;
    },
  },
});

export const { setAuthToken, setUser, setShowDashPopup, setDisConnectWallet } = statusSlice.actions;
export default statusSlice.reducer;
